import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from "@mui/material";
import classOf2026Logos from "../../images/class-of-2026-college-logos.png";

const groupData = [
  {
    title: "Boys",
    players: [
      ["Adrian", "Munoz", "Wentworth Institute of Technology"],
      ["Anthony", "Ruggiero", "SUNY Canton"],
      ["Brady", "Patrick", "Mount St. Mary College"],
      ["Brandon", "Cruz", "University of New Haven"],
      ["Brandon", "Seddio", "St. Joseph's University Long Island"],
      ["Cameron", "Ortiz", "SUNY Canton"],
      ["Derek", "Guise", "St. Joseph's University Long Island"],
      ["Dwight", "Valladeres", "SUNY Geneseo"],
      ["Dylan", "Lopez", "Stony Brook University"],
      ["Eli", "Rubio", "Suffolk County Community College"],
      ["Ethan", "Kyle", "SUNY Plattsburgh"],
      ["Elliot", "Burgueno", "Stony Brook University"],
      ["Estoban", "Loaiza", "SUNY Plattsburgh"],
      ["Gavin", "Macrina", "St. Joseph's University Long Island"],
      ["Isaiah", "Vidal", "Westminster College"],
      ["Jared", "Rivers", "Farmingdale State College"],
      ["John", "Caso", "Stony Brook University"],
      ["Lenny", "Ortiz", "Farmingdale State College"],
      ["Luke", "Pena", "SUNY Oswego"],
      ["Mathaus", "Faria", "Farmingdale State College"],
      ["Matt", "Brita", "College of Staten Island"],
      ["Sean", "Griffin", "SUNY Oneonta"],
      ["Tristan", "Dent", "Suffolk County Community College"],
    ],
  },
  {
    title: "Girls",
    players: [
      ["Alex", "Chmela", "Molloy University"],
      ["Alicia", "Herrera", "St. Joseph's University Long Island"],
      ["Aubrey", "Firenze", "SUNY New Paltz"],
      ["Biaca", "Clarke", "Farmingdale State College"],
      ["Brianna", "Tobia", "Georgian Court"],
      ["Emani", "Abdool", "SUNY Maritime"],
      ["Katherine", "Edwards", "Mount St. Mary College"],
      ["Layla", "Keltai", "Clark University"],
      ["Leah", "Valasquez", "Bridgewater State University"],
      ["Marisa", "Ruland", "Molloy University"],
      ["Meghan", "Vahle", "St. Joseph's University Long Island"],
      ["Mia", "Mangano", "Johnson & Wales University"],
      ["Peyton", "Hughes", "Southern Wesleyan"],
      ["Taylor", "Unzervagt", "Wentworth Institute of Technology"],
    ],
  },
];

export default function CollegeCommits() {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        color: "#001a3d",
        backgroundImage: {
          xs: "none",
          sm: `url(${classOf2026Logos})`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="overline"
            sx={{
              display: "inline-block",
              bgcolor: "rgba(226, 29, 43, 0.08)",
              color: "white",
              border: "1px solid white",
              px: 1.5,
              py: 0.75,
              borderRadius: 999,
              fontWeight: 700,
              letterSpacing: "0.12em",
            }}
          >
            2025-2026 graduating class
          </Typography>
          <Typography
            variant="h3"
            sx={{
              mt: 2,
              fontWeight: 800,
              color: "white",
              fontSize: { xs: "2rem", md: "3rem" },
            }}
          >
            College Commits
          </Typography>
        </Box>

        <Grid container spacing={3} alignItems="stretch" justifyContent="center">
          {groupData.map((group) => (
            <Grid item xs={12} md={6} key={group.title} sx={{ display: "flex", justifyContent: "center" }}>
              <Paper
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  background: "linear-gradient(180deg, rgba(0, 0, 24, 0.86) 0%, rgba(0, 20, 50, 0.86) 100%)",
                  color: "#e9eef6",
                  border: "1px solid rgba(255,255,255,0.12)",
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                }}
              >
                <Box
                  sx={{
                    px: 2.5,
                    py: 2,
                    bgcolor: "rgba(255,255,255,0.04)",
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 800, color: "#ffffff" }}>
                    {group.title}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    px: 2,
                    py: 1.5,
                    overflowY: "auto",
                    maxHeight: 620,
                    minHeight: 620,
                    "&::-webkit-scrollbar": {
                      width: 8,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: 999,
                    },
                  }}
                >
                  {group.players.map(([first, last, school], index) => (
                    <Box
                      key={`${group.title}-${first}-${last}`}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "minmax(0, 1.2fr) minmax(0, 1.8fr)",
                        gap: 2,
                        py: 1,
                        px: 1,
                        borderBottom:
                          index === group.players.length - 1 ? "none" : "1px solid rgba(255,255,255,0.06)",
                        color: "#edf4ff",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 700,
                          color: "#ffffff",
                          opacity: 0.96,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {first} {last}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: "#b7cceb",
                          fontWeight: 700,
                          lineHeight: 1.5,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "left",
                        }}
                      >
                        {school}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
